import BeachAccessIcon from "@mui/icons-material/BeachAccess";
import { VACATION_LIST, EmployeeServicePath } from "utils/constants";
import ListVacations from "./List";
import permissions from "app/permissions";

export const resources = {
  isMenu: true,
  icon: <BeachAccessIcon />,
  name: EmployeeServicePath + VACATION_LIST,
  title: "Отпуски",
  list: <ListVacations />,
  permission: permissions.canPreviewLeaveRequests,
};
